export type MappingValueState =
  | { kind: 'source'; source: string }
  | { kind: 'join'; sources: readonly string[] }
  | { kind: 'static' }
  | null;

export interface MappingTargetDraft {
  selected: boolean;
  required: boolean;
  joined?: boolean;
}

export interface MappingTargetStateInput {
  selected: boolean;
  required: boolean;
  value: MappingValueState;
  disabled?: boolean;
  supportsJoin?: boolean;
  supportsStatic?: boolean;
}

export function mappingTargetState(input: MappingTargetStateInput) {
  const selected = input.selected || input.required;
  const hasValue = input.value?.kind === 'static' || (input.value?.kind === 'source'
    ? input.value.source.trim().length > 0 : input.value?.kind === 'join' && input.value.sources.length > 0);
  const mapped = selected && !!hasValue;
  const joined = selected && input.value?.kind === 'join';
  return {
    selected,
    required: input.required,
    mapped,
    joined,
    state: mapped ? 'mapped' as const : input.required ? 'required-unmapped' as const : 'unmapped' as const,
    selectionDisabled: !!input.disabled || input.required,
    requiredDisabled: !!input.disabled,
    mappingDisabled: !!input.disabled || !selected,
    joinVisible: !!input.supportsJoin,
    joinDisabled: !!input.disabled || !selected,
    staticDisabled: !!input.disabled || !selected || !input.supportsStatic || joined,
    removeVisible: mapped,
    removeDisabled: !!input.disabled,
  };
}

export type MappingTargetEvent =
  | { type: 'select'; selected: boolean }
  | { type: 'required'; required: boolean }
  | { type: 'remove-source' }
  | { type: 'remove' };

export function transitionMappingTarget(input: MappingTargetStateInput, event: MappingTargetEvent) {
  const state = mappingTargetState(input);
  if (input.disabled) return { selected: state.selected, required: state.required, preserveValue: true };
  if (event.type === 'remove-source') return { selected: state.selected, required: state.required, preserveValue: false };
  if (event.type === 'remove') return { selected: state.required, required: state.required, preserveValue: false };
  if (event.type === 'required') return {
    selected: event.required || state.mapped,
    required: event.required,
    preserveValue: state.mapped,
  };
  return {
    selected: event.selected || state.required,
    required: state.required,
    preserveValue: event.selected || state.required,
  };
}